import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  useCallback,
  startTransition,
} from 'react';
import ScappAppbar from './Components/ScappAppbar';
import MenuRegion from './pages/MenuRegion';
import MenuAnalitica from './pages/Dashboard/MenuAnalitica';
import FullScappV2 from './pages/Dashboard/v2/full/FullScappV2';
import MenuAnaliticaSimple from './pages/Dashboard/MenuAnaliticaSimple';
import ComparadorCentros from './pages/Dashboard/MenuComparativo';
import MenuInsightDashboard from './pages/Dashboard/Insight/MenuInsightDashboard';
import MenuFeederScore from './pages/Dashboard/FeederScore/MenuFeederScore';
import MenuAlarmAttention from './pages/Dashboard/FeederScore/MenuAlarmAttention';
import AnalyticsXlsxExportButton from './Components/utils/AnalyticsXlsxExportButton';
// import { Box, Skeleton } from '@mui/material';
import { Box, Skeleton, CircularProgress } from '@mui/material';

import { useServer } from '../../context/ServerContext';

import './utils/MainScapp.css';
import { 
  get_data_scapp, 
  get_data_area_scapp, 
  get_data_region_scapp, 
  get_centers_access ,
} from './utils/api';

import { CompactarDatos } from './utils/CompactarDatosAnalitica';
import { buildAssistantScappContext } from "./utils/buildAssistantScappContext";
import useAssistantViewContext from "../../features/ai-assistant/useAssistantViewContext";
import useAssistantScappContext from "../../features/ai-assistant/useAssistantScappContext";
import { buildAssistantViewContext } from "../../features/ai-assistant/documentationKeyResolver";
import { canViewFeederScore } from "../../features/ai-usage/aiUsageClient";

import { groupChartData } from './utils/groupChartData';
import { normalizeRateAnalytics } from './utils/feedingRates';

// Simple Skeleton component
const Carga = React.memo(({ width = '100%', height = '1em', style }) => {
  return(
    <Box display="flex" width="100%" height="100vh" gap={'0.4vh'}>
      {/* Left column */}
      <Box flex={4} display="flex" flexDirection="column" gap={'0.4vh'}>
        {/* Row 1 */}
        <Box display="flex" gap={'0.4vh'} >
          <Skeleton variant="rectangular" width="60%" height="29.6vh" sx={{borderRadius:"0.5vw" }} />
          <Skeleton variant="rectangular" width="40%" height="29.6vh" sx={{borderRadius:"0.5vw" }}/>
        </Box>

        {/* Row 2 */}
        <Box display="flex" gap={'0.4vh'}>
          <Skeleton variant="rectangular" width="50%" height="29.6vh"sx={{borderRadius:"0.5vw" }}/>
          <Skeleton variant="rectangular" width="50%" height="29.6vh"sx={{borderRadius:"0.5vw" }}/>
        </Box>

        {/* Row 3 */}
        <Box display="flex" gap={'0.4vh'}>
          <Skeleton variant="rectangular" width="50%" height="29.6vh"sx={{borderRadius:"0.5vw" }}/>
          <Skeleton variant="rectangular" width="50%" height="29.6vh"sx={{borderRadius:"0.5vw" }}/>
        </Box>
      </Box>

      {/* Right column */}
      <Box flex={1} display="flex">
        {/* This Skeleton spans the full height of the container */}
        <Skeleton variant="rectangular" width="100%" height="89.7%" sx={{borderRadius:"0.5vw" }} />
      </Box>
      </Box>
  )

});
   

function capitalize(value) {
  if (!value) return '';
  let words = value.toLowerCase().split(' ');
  let capitalizedWords = words.map(word => {
    word = word.replace(/los/gi, 'Los ').replace(/puerto/gi, 'Puerto ');
    return word.split(' ').map(part => part.charAt(0).toUpperCase() + part.slice(1)).join(' ');
  });
  return capitalizedWords.join(' ').trim();
}

const formatDate = date => {
  const d = new Date(date);
  const yyyy = d.getFullYear();
  const mm   = String(d.getMonth()+1).padStart(2,'0');
  const dd   = String(d.getDate()).padStart(2,'0');
  return `${dd}-${mm}-${yyyy}`;
};


function usePersistedState(key, defaultValue) {
  const [value, setValue] = useState(() => {
    const stored = localStorage.getItem(key);
    if (stored !== null) {
      try {
        // Si había un JSON válido, lo parseamos
        return JSON.parse(stored);
      } catch {
        // Si no, devolvemos la cadena “cruda”
        return stored;
      }
    }
    return defaultValue;
  });

  useEffect(() => {
    // Siempre guardamos como JSON (incluso si es una cadena, la stringify incluye las comillas)
    localStorage.setItem(key, JSON.stringify(value));
  }, [key, value]);

  return [value, setValue];
}

function renameKeysDeep(input) {
  if (Array.isArray(input)) {
    return input.map(renameKeysDeep);
  }
  if (input && typeof input === 'object') {
    const out = {};
    for (const [key, value] of Object.entries(input)) {
      let newKey = key;
      if (key === 'perdidos_cout') newKey = 'perdidos_count';
      if (key === 'visitas_cout')  newKey = 'visitas_count';

      // Evitar pisar un valor ya "correcto" si existieran ambas variantes
      if (newKey in out && newKey !== key) {
        // Si ya existe la clave correcta, preferimos mantenerla
        // (opcional: podrías decidir combinar/validar aquí)
        continue;
      }
      out[newKey] = renameKeysDeep(value);
    }
    return out;
  }
  return input;
}


const MainScapp = ({ translate, idioma }) => {

  const { servidor, aiWebhookUrl } = useServer();
  const [compact, setCompact] = useState(false); 
  const [simpleView, setSimpleView] = useState(false); 
  const [dashboardVersion, setDashboardVersion] = usePersistedState('SCAPP_DASHBOARD_VERSION', 'v1');
  const [nivelSeleccionado, setNivelSeleccionado] = useState('centro');
  const [nameVista, setNameVista] =useState ('')
  const [groupMode, setGroupMode] = useState("day");

  const [alarmGraph, setAlarmGraph] = useState([ 'alarms_count','alarms_by_visits',]);
  
  const [permisosCentros, setPermisosCentros] = useState(null);
  const [regionSeleccionada, setRegionSeleccionada] = usePersistedState('REGION', '');
  const [areaSeleccionada, setAreaSeleccionada]     = usePersistedState('AREA', '');
  const [centroSeleccionado, setCentroSeleccionado] = usePersistedState('CENTRO', '');
  // const [pendienteData, setPendienteData]           = useState(false);

  const [versus, setVersus] = useState([]);

  const [jaulaSeleccionada, setJaulaSeleccionada] = useState('');
  const [selectedDay, setSelectedDay] = useState('');
  const [viewMode, setViewMode] = useState('week');
  const [fastingResolution, setFastingResolution] = useState('half_day');
  const [selectedRateKey, setSelectedRateKey] = useState('auto');
  const [view, setView] = useState('dashboard');
  const [xlsxExport, setXlsxExport] = useState(null);
  const feederScoreAllowed = canViewFeederScore(localStorage.getItem("cargo"));

  const [selectedCenters, setSelectedCenters] = useState([]);
  
  const [data, setData] = useState(null);

  const registerXlsxExport = useCallback((registration) => {
    setXlsxExport(registration);
  }, []);
  const clearXlsxExport = useCallback((id) => {
    setXlsxExport((current) => (current?.id === id ? null : current));
  }, []);

  // console.log('data', data);
  const dataCacheRef = useRef(new Map());
  const currentDataRef = useRef(null);
  const requestSequenceRef = useRef(0);
  const datosCompactados = useMemo(
    () =>
      compact && nivelSeleccionado === 'centro'
        ? CompactarDatos(data)
        : data || {},
    [compact, data, nivelSeleccionado]
  );

  // console.log('datosCompactados',datosCompactados)
  /* ───────────── Normalización ───────────── */
  const groupedAnalyticData = useMemo(() => {
    if (!datosCompactados?.analytic_data) return {};
    if (groupMode === 'day') return datosCompactados.analytic_data;

    const entries = Object.entries(datosCompactados.analytic_data);

    return entries.reduce((acc, [key, jaula]) => {
      const grouped = groupChartData([jaula], groupMode)[0];

      acc[key] = grouped;
      return acc;
    }, {});
  }, [datosCompactados, groupMode]);

  const finalData = useMemo(() => {
    if (!datosCompactados?.analytic_data) return datosCompactados || {};
    return {
      ...datosCompactados,
      analytic_data: groupedAnalyticData,
    };
  }, [datosCompactados, groupedAnalyticData]);


  
  // const permisosJaula = Object.values(datosCompactados?.analytic_data ?? {}).map(item => item.name);
  const permisosJaula = useMemo(
    () => Object.values(finalData?.analytic_data ?? {}).map(item => item.name),
    [finalData]
  );

  const [initialLoading, setInitialLoading] = useState(true);
  const [backgroundFetching, setBackgroundFetching] = useState(false);
  const loading = initialLoading || backgroundFetching;

  const [dias, setDias] = useState(() => {
    const stored = localStorage.getItem('RangoDiasScapp');
    if (stored) {
      try { return JSON.parse(stored); } 
      catch (err) { console.warn('Error parsing RangoDiasScapp:', err); }
    }
    const today = formatDate(new Date());
    return { startDate: today, endDate: today, dayRange: 1 };
  });

  const assistantViewContext = useMemo(
    () => {
      const documentationVariant =
        view === "insight"
          ? "insight"
          : view === "versus"
          ? "comparacion"
          : simpleView
            ? "simple"
            : "general";

      return buildAssistantViewContext({
        service: "scapp",
        module: "analytics",
        view: documentationVariant,
        entities: {
          region: regionSeleccionada || "",
          area: areaSeleccionada || "",
          centro: centroSeleccionado || "",
        },
        filters: {
          dias,
          viewMode,
          selectedDay,
        },
        uiState: {
          compact,
          simpleView,
          loading,
          layoutLevel: nivelSeleccionado,
          comparisonMode: view,
        },
      });
    },
    [
      areaSeleccionada,
      centroSeleccionado,
      compact,
      dias,
      loading,
      nivelSeleccionado,
      regionSeleccionada,
      selectedDay,
      simpleView,
      view,
      viewMode,
    ]
  );

  useAssistantViewContext(assistantViewContext);

  const assistantScappContext = useMemo(
    () =>
      buildAssistantScappContext({
        viewContext: assistantViewContext,
        data: datosCompactados,
        versus,
        selectedCenters,
        selectedDay,
        jaulaSeleccionada,
        loading,
      }),
    [
      assistantViewContext,
      datosCompactados,
      jaulaSeleccionada,
      loading,
      selectedCenters,
      selectedDay,
      versus,
    ]
  );

  useAssistantScappContext(assistantScappContext);

  useEffect(() => {
    if ((view === 'feederScore' || view === 'alarmAttention') && !feederScoreAllowed) {
      setView('dashboard');
    }
  }, [feederScoreAllowed, view]);

  const handleToggle = useCallback(() => {
    startTransition(() => {
      setView(v => v === 'dashboard' ? 'versus' : 'dashboard');
    });
  }, []);

  // Para compactar datos
  const onCompactClick = useCallback(() => {
    console.log('Toggling compact');
    startTransition(() => {
      setCompact(prev => !prev);
    });
  }, []);

  useEffect(() => {
    currentDataRef.current = data;
  }, [data]);



  // Fetch data on changes
  useEffect(() => {
    const { startDate, dayRange } = dias || {};
    if (!startDate || !dayRange || !nivelSeleccionado ) return;

    const requestKey = JSON.stringify({
      servidor,
      nivelSeleccionado,
      regionSeleccionada,
      areaSeleccionada,
      centroSeleccionado,
      startDate,
      dayRange,
    });

    const cachedData = dataCacheRef.current.get(requestKey);
    if (cachedData) {
      setInitialLoading(false);
      setBackgroundFetching(false);
      if (currentDataRef.current !== cachedData) {
        setData(cachedData);
      }
      return;
    }

    let isActive = true;
    const requestId = ++requestSequenceRef.current;
    const hasVisibleData = Boolean(currentDataRef.current);

    if (hasVisibleData) {
      setInitialLoading(false);
      setBackgroundFetching(true);
    } else {
      setInitialLoading(true);
      setBackgroundFetching(false);
    }

    const fetchData = async () => {
      try {

        const REGION = regionSeleccionada;
        const AREA = areaSeleccionada ;
        const CENTRO = centroSeleccionado ;
        const FECHA = startDate;
        const CANTIDAD_DIAS = dayRange;
        let result;
        switch (nivelSeleccionado) {
          case 'centro':
            result = await get_data_scapp(REGION, AREA, CENTRO, FECHA, CANTIDAD_DIAS, servidor);
            break;
          case 'area':
            result = await get_data_area_scapp(REGION, AREA, FECHA, CANTIDAD_DIAS, servidor);
            break;
          case 'region':
            result = await get_data_region_scapp(REGION, FECHA, CANTIDAD_DIAS, servidor);
            break;
          default:
            return;
        }
        // setData(result);
        // normalizamos claves antes de guardar
        const normalized = normalizeRateAnalytics(renameKeysDeep(result));
        dataCacheRef.current.set(requestKey, normalized);
        if (isActive && requestSequenceRef.current === requestId) {
          setData(normalized);
        }
      } catch (error) {
        console.error('Error al obtener los datos:', error);
      } finally {
        if (isActive && requestSequenceRef.current === requestId) {
          setInitialLoading(false);
          setBackgroundFetching(false);
        }
      }
    };

    fetchData();

    return () => {
      isActive = false;
    };
  }, [dias, nivelSeleccionado, regionSeleccionada, areaSeleccionada, centroSeleccionado, servidor]);

  // Fetch permissions once
  useEffect(() => {
    (async () => {
      try {
        const perms = await get_centers_access(servidor);
        setPermisosCentros(perms);
      } catch (err) {
        console.error(err);
      }
    })();
  }, [servidor]);

  // nombre en appbar
  useEffect(() => {
    if (nivelSeleccionado === 'area') {
      setNameVista(areaSeleccionada || '');
    } else if (nivelSeleccionado === 'region') {
      setNameVista(regionSeleccionada || '');
    } else {
      // Cualquier otro valor (incluido ''), se toma centroSeleccionado
      setNameVista(centroSeleccionado || '');
    }
  }, [nivelSeleccionado, areaSeleccionada, regionSeleccionada, centroSeleccionado]);


  useEffect(() => {
    setJaulaSeleccionada('');
  }, [nivelSeleccionado]);

  const ScappAppbarProps = useMemo(() => ({
    capitalize,
    translate,
    idioma,
    handleToggle,
    view,setView, setViewMode,
    permisosCentros,
    dias,setDias,
    versus,
    setVersus,
    // setPermisosCentros,
    // data,
    data: finalData,//datosCompactados,
    regionSeleccionada, setRegionSeleccionada,
    areaSeleccionada, setAreaSeleccionada,
    centroSeleccionado,setCentroSeleccionado,
    selectedCenters, setSelectedCenters,
    selectedDay, setSelectedDay,
    jaulaSeleccionada,
    viewMode,
    fastingResolution,
    setFastingResolution,
    selectedRateKey,
    setSelectedRateKey,
    showRateToggle: view === 'dashboard',
    isComparisonView: view === 'versus',
    nivelSeleccionado, setNivelSeleccionado,
    nameVista, permisosJaula,
    onCompactClick, compact,
    simpleView, setSimpleView,
    dashboardVersion, setDashboardVersion,
    setGroupMode, groupMode,
    xlsxExport,
  }), [
    translate,
    idioma,
    handleToggle,
    view,
    setView,
    setViewMode,
    permisosCentros,
    dias,
    setDias,
    versus,
    setVersus,
    finalData,
    regionSeleccionada,
    setRegionSeleccionada,
    areaSeleccionada,
    setAreaSeleccionada,
    centroSeleccionado,
    setCentroSeleccionado,
    selectedCenters,
    setSelectedCenters,
    selectedDay,
    setSelectedDay,
    jaulaSeleccionada,
    viewMode,
    fastingResolution,
    setFastingResolution,
    selectedRateKey,
    setSelectedRateKey,
    nivelSeleccionado,
    setNivelSeleccionado,
    nameVista,
    permisosJaula,
    onCompactClick,
    compact,
    simpleView,
    setSimpleView,
    dashboardVersion,
    setDashboardVersion,
    setGroupMode,
    groupMode,
    xlsxExport,
  ]);

  const MenuAnaliticaProps = useMemo(() => ({
    data: finalData,//datosCompactados,
    translate,
    // datos: data,
    dias,
    setDias,
    selectedDay, setSelectedDay,
    jaulaSeleccionada, setJaulaSeleccionada,
    viewMode,
    fastingResolution,
    selectedRateKey,
    nivelSeleccionado,
    datosRegion:data,
    alarmGraph, setAlarmGraph
    
  }), [
    finalData,
    translate,
    dias,
    setDias,
    selectedDay,
    setSelectedDay,
    jaulaSeleccionada,
    setJaulaSeleccionada,
    viewMode,
    fastingResolution,
    selectedRateKey,
    nivelSeleccionado,
    data,
    alarmGraph,
    setAlarmGraph,
  ]);

  const ComparadorCentrosProps = useMemo(() => ({
    translate,
    setSelectedCenters, 
    selectedCenters, 
    versus,
    dias,
    setDias,
    // data,
    data: finalData,//datosCompactados,
    nivelSeleccionado,
    alarmGraph, setAlarmGraph

  }), [
    translate,
    setSelectedCenters,
    selectedCenters,
    versus,
    dias,
    setDias,
    finalData,
    nivelSeleccionado,
    alarmGraph,
    setAlarmGraph,
  ]);

  const MenuInsightDashboardProps = useMemo(() => ({
    scappContext: assistantScappContext,
    aiWebhookUrl,
    translate,
  }), [aiWebhookUrl, assistantScappContext, translate]);

  const feederScoreView = view === 'feederScore' || view === 'alarmAttention';
  const shouldShowSkeleton = initialLoading && !data && !feederScoreView;
  const feederScoreProps = useMemo(() => ({
    translate,
    servidor,
    dias,
    groupMode,
    nivelSeleccionado,
    regionSeleccionada,
    areaSeleccionada,
    centroSeleccionado,
    registerXlsxExport,
    clearXlsxExport,
  }), [
    translate,
    servidor,
    dias,
    groupMode,
    nivelSeleccionado,
    regionSeleccionada,
    areaSeleccionada,
    centroSeleccionado,
    registerXlsxExport,
    clearXlsxExport,
  ]);

  // Render
  if (dashboardVersion === 'v2' && view === 'dashboard') {
    return <FullScappV2
      {...ScappAppbarProps}
      {...MenuAnaliticaProps}
      dailyData={datosCompactados}
      compact={compact}
      groupMode={groupMode}
      setGroupMode={setGroupMode}
      setViewMode={setViewMode}
      setDashboardVersion={setDashboardVersion}
      servidor={servidor}
      loading={loading}
      initialLoading={shouldShowSkeleton}
    />;
  }
  return (
    <div style={{ height: '100vh', overflow: 'hidden',  }}>
      <ScappAppbar {...ScappAppbarProps} />
      {/* <Box position="absolute" top="70px" right="-20px" zIndex={10}>
        <FormControlLabel
          control={
            <Switch
              checked={simpleView}
              onChange={() => setSimpleView(!simpleView)}
              color="primary"
            />
          }
          label={simpleView ? "Vista simple" : "Vista detallada"}
        />
      </Box> */}
      <div className="MainScapp-container">
        <div className="view-container" style={{ position: 'relative' }}>
          {shouldShowSkeleton ? (
            <div className="skeleton-view">
              <Carga height="2.5rem" />
            </div>
          ) : (
            // <div className="view">
            //   {view === 'dashboard'
            //     ? (nivelSeleccionado === 'region'
            //         ? <MenuRegion {...MenuAnaliticaProps} />
            //         : <MenuAnalitica {...MenuAnaliticaProps}  compact={compact}/>)
            //     : <ComparadorCentros {...ComparadorCentrosProps} />
            //   }
            // </div>
            <>
              {backgroundFetching && (
                <Box
                  sx={{
                    position: 'absolute',
                    top: '0.8vh',
                    right: '1vw',
                    zIndex: 20,
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.45vw',
                    px: '0.6vw',
                    py: '0.4vh',
                    borderRadius: '999px',
                    border: '0.01vw solid rgba(232, 78, 14, 0.35)',
                    backgroundColor: 'rgba(19, 19, 31, 0.88)',
                    color: '#c3c3c3',
                    pointerEvents: 'none',
                    boxShadow: '0 0.2vw 0.6vw rgba(0,0,0,0.16)',
                  }}
                >
                  <CircularProgress size={14} thickness={5} sx={{ color: '#e84e0e' }} />
                  <Box component="span" sx={{ fontSize: '0.65vw', fontWeight: 700 }}>
                    Actualizando...
                  </Box>
                </Box>
              )}

            <div className="view">
              {view === 'dashboard' && (
                <AnalyticsXlsxExportButton
                  data={finalData}
                  dias={dias}
                  nivelSeleccionado={nivelSeleccionado}
                  groupMode={groupMode}
                  compact={compact}
                  selectedDay={selectedDay}
                  selectedRateKey={selectedRateKey}
                  selectedEntity={jaulaSeleccionada}
                  region={regionSeleccionada}
                  area={areaSeleccionada}
                  center={centroSeleccionado}
                  translate={translate}
                  registerXlsxExport={registerXlsxExport}
                  clearXlsxExport={clearXlsxExport}
                />
              )}
              {view === 'insight' ? (
                <MenuInsightDashboard {...MenuInsightDashboardProps} />
              ) : view === 'feederScore' ? (
                <MenuFeederScore {...feederScoreProps} />
              ) : view === 'alarmAttention' ? (
                <MenuAlarmAttention {...feederScoreProps} />
              ) : view === 'dashboard' ? (
                nivelSeleccionado === 'region' ? (
                  <MenuRegion {...MenuAnaliticaProps} />
                ) : simpleView ? (
                  <MenuAnaliticaSimple {...MenuAnaliticaProps} /> // 👈 vista simple
                ) : (
                  <MenuAnalitica {...MenuAnaliticaProps} compact={compact} /> // 👈 vista detallada
                )
              ) : (
                <ComparadorCentros {...ComparadorCentrosProps} />
              )}
            </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default MainScapp;
